import ReactGA from 'react-ga';
import Axios from 'axios';
import { reaction } from 'mobx';
import {
  fbVisitPageTrack,
  initAmplitude,
  initFB,
  initGA,
  initYM,
} from '../utils/client-analytics.util';
import { stores } from '../../stores';
import { log } from '../utils/logging.util';
import { paramsToObject } from '../utils/common.utils';
import { appConfig } from '../../config';

class AnalyticsService {
  init() {
    const params = paramsToObject(new URLSearchParams(window.location.search));

    const { subid } = params;

    if (subid) {
      // binomId depends on 'authToken'
      // reaction below tracks if authToken changes and if so we reassign it
      reaction(
        () => ({
          authToken: stores.AuthStore.session.app_token,
        }),
        ({ authToken }) => {
          if (authToken) {
            stores.AnalyticsStore1.setAuthToken(authToken);
            stores.AnalyticsStore1.setAndSaveBinomID(subid);
          }
        },
      );
    }

    const GA_ID = process.env.REACT_APP_GA_ID;

    if (GA_ID) {
      if (appConfig.whiteLabelPartner === 'rock-west') {
        initGA(process.env.REACT_APP_GA_ID);
        ReactGA.pageview(window.location.pathname + window.location.search);
      }
    }

    initFB(process.env.REACT_APP_FB_ID);
    fbVisitPageTrack();

    initAmplitude();
    initYM(process.env.REACT_APP_YM_ID);
  }

  sendBinomEvent = (event) => {
    const subid = stores.AnalyticsStore1.getBinomID;
    if (subid) {
      return process.env.REACT_APP_ENABLE_POSTBACKS
        ? Axios.post(
          `https://linkttrk.click/click.php?cnv_id=${subid}&${event}=1`,
        )
        : null;
    }
    log(`cant send event ${event} to Binom, no subid found`, 'error');
  };

  trackDLineEvent = (eventName) => {
    if (window._lt) {
      window._lt(
        'send',
        'cv',
        {
          type: 'Conversion',
        },
        [eventName],
      );
    } else {
      log('[Analytics] No _lt fn in window', 'warn');
    }
  };

  trackDLineRegistrationPageVisit = () => {
    this.trackDLineEvent('bc8aa21c-67ad-4482-b1ee-6ea617d1ea0b');
  };
}

export const analyticsService = new AnalyticsService();
